import { useQuery } from '@tanstack/react-query';
import { fetchAvailableRoles } from '../services/userRbac';
import type { AvailableRole } from '../types/users.types';

export const availableRoleKeys = {
    all: ['users', 'available-roles'] as const,
    lists: () => [...availableRoleKeys.all, 'list'] as const,
};

export const useAvailableRolesQuery = () => {
    return useQuery<AvailableRole[]>({
        queryKey: availableRoleKeys.lists(),
        queryFn: fetchAvailableRoles,
        staleTime: 10 * 60 * 1000,
        gcTime: 30 * 60 * 1000,
    });
};
